import { useEffect } from "react";
import "./FeedbackArea.css";

export const FeedbackArea = ({ visible, onHide }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(onHide, 3000);
      return () => clearTimeout(timer);
    }
  }, [visible, onHide]);

  return (
    <div className={`feedback-area ${visible ? "active" : ""}`}>
      Grazie per il feedback
    </div>
  );
};
